/**
 * Created by akirilyuk on 9/14/16.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        Button = require("ui/button/Button"),
        template = require("connection-templates/ticketTab/extendedList/attachmentUploadInput.tmpl"),
        AttachmentsCollection = require("connection-collections/ticketTab/AttachmentsCollection"),
        AttachmentModel = require("connection-models/ticketTab/AttachmentModel"),
        Loader = require("ui/loader/Loader"),
        CP_CONST = require("connection-const"),
        AttachmentUploadInput = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        AttachmentUploadInput = Marionette.ItemView.extend({
            template: template,
            className: 'attachment-upload-input',
            ui:{
                fileUpload: ".file-upload",
                loaderContainer: ".loader-container",
                fileUploadButton: ".file-upload-button"
            },
            uiComponents:{
                fileUploadButton: {
                    type: Button,
                    options:{
                        el: "view.ui.fileUploadButton",
                        permutation: Button.PERMUTATION.BTN_SHORT,
                        text:LE.translator.translate("LEConnection.cases.attachmentUpload.input.selectFile")
                    },
                    events:{
                        "click": "_onFileSelectClick"
                    }
                }
            },
            events:{
                "change .file-upload" : "_onFileSelect"
            },
            initialize:function(options){
                this.container = options.el;
                this.collection = options.collection;
                this.type = options.type || AttachmentsCollection.TYPES.DEFAULT;
            },
            onRender: function(){
                $(this.container).append(this.el);
                this.ui.fileUpload.placeholder = LE.translator.translate("LEConnection.cases.attachmentUpload.input.noFile");
                this.ui.fileUpload.text = LE.translator.translate("LEConnection.cases.attachmentUpload.input.selectFile");
            },
            setDisabled: function(disabled){
                //this is needet to acces the fileupload object, no problems here
                this.uiComponents.fileUploadButton.setEnabled(!disabled);
            },
            _resetFileInput:function(){
                if(this.getIsRendered()){
                    $(this.ui.fileUpload).val("");
                }
                this._closeLoader();
            },
            _setLoader:function(){
                this._getLoader().render();
            },
            _closeLoader: function () {
                this._getLoader().close();
            },
            _getLoader:function(){
                if (!this.loader) {
                    this.loader = new Loader({
                        permutation: Loader.PERMUTATION.L,
                        el: this.ui.loaderContainer,
                        zIndex:2
                    });
                }
                return this.loader;
            },

            _onFileSelectClick: function(){
                $(this.ui.fileUpload).click();
            },
            _onFileSelect: function(){
                this._setLoader();
                this._getFile();
            },
            _getFile: function(){
                var file = null;
                if(this.ui.fileUpload&&this.ui.fileUpload.get("0")) {
                    file = this.ui.fileUpload.get("0").files[0];
                }
                if(file) {
                    var maxSize = CP_CONST.ATTACHMENTS.MAX_SIZE || 5242880; // 5MB
                    //todo store this value in config + translation
                    if (file.size > maxSize) {
                        LEConnection.notifier.showErrorExtended(LE.translator.translate("LEConnection.cases.attachmentUpload.error.fileTooBig"));
                        this._resetFileInput();
                        return;
                    }
                    var newAttachment = new AttachmentModel({filename: file.name,
                        contentType: file.type || "application/octet-stream", // this fixes undefined mime types
                        body: "",unsaved:true,
                        bodyLength:file.size,
                        type: this.type
                    });
                    var that = this;
                    var reader = new FileReader();
                    reader.onload = function (readerEvt) {
                        var dataUrl = readerEvt.target.result;
                        //start after the comma, where the base64 string is stored
                        var start = dataUrl.indexOf(",")+1;
                        var base64 = dataUrl.slice(start);
                        newAttachment.set("body", base64);
                        that.collection.addEncodedAttachment(newAttachment);
                        that._resetFileInput();
                    };
                    reader.onerror = function(readerEvt){
                        LEConnection.notifier.showErrorExtended(LE.translator.translate("LEConnection.cases.attachmentUpload.error.otherError"));
                        LEConnection.logger.error("file read error, something went wrong while parsing the file" + JSON.stringify(file));
                        that._resetFileInput();
                    };
                    reader.readAsDataURL(file);
                }
            }

        });
    });
    return AttachmentUploadInput;
});

